import { Link, usePage } from "@inertiajs/react"

import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import type { NavItem } from "@/types"

function normalizedNavPath(url: string) {
  const path = url.split(/[?#]/, 1)[0] || "/"
  return path === "/" ? path : path.replace(/\/+$/, "")
}

export function navItemIsActive(
  currentUrl: string,
  item: Pick<NavItem, "href" | "exact">,
) {
  const currentPath = normalizedNavPath(currentUrl)
  const href = normalizedNavPath(item.href)

  return item.exact
    ? currentPath === href
    : currentPath === href ||
        (href !== "/" && currentPath.startsWith(`${href}/`))
}

export function NavMain({ items = [] }: { items: NavItem[] }) {
  const page = usePage()
  return (
    <SidebarGroup className="px-2 py-0">
      <SidebarGroupLabel>Platform</SidebarGroupLabel>
      <SidebarMenu>
        {items.map((item) => {
          const isActive = navItemIsActive(page.url, item)

          return (
            <SidebarMenuItem key={item.title}>
              <SidebarMenuButton
                asChild
                isActive={isActive}
                tooltip={{ children: item.title }}
              >
                <Link href={item.href} prefetch>
                  {item.icon && <item.icon />}
                  <span>{item.title}</span>
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
          )
        })}
      </SidebarMenu>
    </SidebarGroup>
  )
}
